import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/arrowDiagonalRight.svg';

export const IconArrowDiagonalRight = createIconComponent(Icon);
